import React from 'react'

export const Check = ({ size = 16, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>
)

export const Trophy = ({ size = 22, color = 'currentColor', width = 2.2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={width} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M7 4h10v4a5 5 0 0 1-10 0z"></path><path d="M7 6H4a3 3 0 0 0 3 4M17 6h3a3 3 0 0 1-3 4M12 13v4M8 20h8"></path></svg>
)

export const Pen = ({ size = 16, width = 2.2, crossed = false }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={width} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M4 20h4L19 9l-4-4L4 16z"></path><path d="M13.5 6.5l4 4"></path>{crossed && <path d="M3 3l18 18"></path>}</svg>
)

export const ErrorText = ({ id, children }) => (
  <div id={id} className="err" role="alert">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#c7392a" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true"><path d="M12 3l10 18H2z" strokeLinejoin="round"></path><path d="M12 10v5M12 18v.01"></path></svg>
    {children}
  </div>
)

export const Spinner = () => (
  <svg className="spin" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity=".25" strokeWidth="3"></circle><path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round"></path></svg>
)
